import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";

export default class PlaidService extends AbstractService {
	static endpoint = ENDPOINTS.plaid;

	static exchangeToken(data) {
		return this.post({
			endpoint: `${this.endpoint}/exchange`,
			data,
		});
	}
}
